import React, { memo } from "react";
import moment from "moment";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { IoIosArrowDown } from "react-icons/io";
import { CgProfile } from "react-icons/cg";
import { useLoginData } from "component/common/loginData";
import { useNavigate } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import { CARDS_ENUMS } from "helper/constant";
import Button from "component/ui/Button";

const AssignedMatchDetailsDialog = ({ open, data, closeDialog }) => {
  const userData = useLoginData();
  const navigate = useNavigate();
  const detailsData = [
    {
      id: "spotsName",
      Label: "Game or Sports",
      value: data?.category,
      isDisplay: true,
    },
    {
      id: "ageGroup",
      Label: "Age Group",
      value: data?.ageGroup,
      isDisplay: data?.cardType == CARDS_ENUMS?.EVENT,
    },
    {
      id: "gender",
      Label: "Gender",
      value: data?.gender,
      isDisplay: data?.cardType == CARDS_ENUMS?.EVENT,
    },
    {
      id: "location",
      Label: "Location",
      value: data?.location?.address,
      isDisplay: true,
    },
    {
      id: "startDateAndTime",
      Label: "Start Date & Time",
      value: data?.startDateAndTime,
      isDisplay: data?.cardType == CARDS_ENUMS?.EVENT,
    },
    {
      id: "phone",
      Label: "Contact Number",
      value: data?.phone,
      isDisplay: data?.cardType == CARDS_ENUMS?.EVENT,
    },
    {
      id: "eventFees",
      Label: "Venue Name",
      value: `${data?.currencySymbol} ${data?.eventFees}`,
      isDisplay: data?.cardType == CARDS_ENUMS?.EVENT,
    },
    {
      id: "eventLiveBooking",
      Label: "Live Booking Availability",
      value: data?.eventLiveBooking ? "Yes" : "No",
      isDisplay: data?.cardType == CARDS_ENUMS?.EVENT,
    },
    {
      id: "venueName",
      Label: "Venue Name",
      value: data?.venueName,
      isDisplay: data?.cardType == CARDS_ENUMS?.VENUE,
    },
    {
      id: "cardReferenceID",
      Label: "Reference Id",
      value: data?.cardReferenceID,
      isDisplay: data?.cardReferenceID,
    },

    {
      id: "cardCreatedDateTime",
      Label: "Booked For",
      type: "date",
      value: data?.cardCreatedDateTime,
      isDisplay: data?.cardType == CARDS_ENUMS?.JOIN,
    },
    {
      id: "description",
      Label: "Description",
      value: data?.description,
      isDisplay: data?.cardType == CARDS_ENUMS?.JOIN,
    },
    {
      id: "mySkillLevel",
      Label: "My Skill Level",
      value: data?.mySkillLevel,
      isDisplay: data?.cardType == CARDS_ENUMS?.JOIN,
    },
    {
      id: "achievements",
      Label: "My Achievements",
      value: data?.achievements,
      isDisplay: data?.cardType == CARDS_ENUMS?.JOIN,
    },
    {
      id: "achievements",
      Label: "Date & Time",
      value: `${data?.clubRequestCardDate} ${data?.clubRequestCardTime}`,
      isDisplay: data?.cardType == CARDS_ENUMS?.JOIN,
    },
    {
      id: "startDate",
      Label: "Start Date & Time",
      type: "date",
      value: data?.startDateAndTime,
      isDisplay: data?.cardType == CARDS_ENUMS?.VENUE,
    },

    {
      id: "playersNo",
      Label: "No Of Players Attending",
      value: data?.noOfPlayreAttanding,
      isDisplay: data?.cardType == CARDS_ENUMS?.VENUE,
    },
  ];
  console.log("sssssssssssssssss", data);
  return (
    <>
      {open && (
        <div
          onClick={closeDialog}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/65 backdrop-blur-lg animate-fadeIn"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="container m-auto w-full h-full overflow-hidden bg-white shadow-2xl animate-slideUp font-poppins "
          >
            {/* Header */}
            <div className="relative overflow-hidden bg-gradient-to-br from-[#2bace2] to-[#1a8fc9] px-5 py-3 max-sm:px-6 max-sm:py-5">
              <div className="relative z-10 flex items-center justify-between">
                <h2 className="text-white text-2xl font-semibold">
                  {data?.cardType == CARDS_ENUMS?.JOIN ? "Card" : "Order"}{" "}
                  Details
                </h2>
                <button
                  onClick={closeDialog}
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-white/20 text-white text-xl transition-all hover:bg-white/30 hover:rotate-90"
                >
                  ✕
                </button>
              </div>
            </div>

            {/* Content */}
            <div className="p-8 overflow-y-auto max-h-[calc(90vh-100px)] max-sm:p-6">
              {/* Buyer */}

              <div className="flex gap-3 border-b-2 pb-3 items-center w-full mb-3 ">
                {data?.profileImageUrl ? (
                  <div
                    className="md:w-16 md:h-16 w-5 rounded-full ring-2"
                    style={{
                      backgroundImage: `url("${data?.profileImageUrl}")`,
                      backgroundSize: "cover",
                    }}
                  ></div>
                ) : (
                  <div className="md:w-10 md:h-10 w-5 flex justify-center items-center font-semibold text-white rounded-full bg-highlight ring-2">
                    {data?.name && data?.name?.charAt(0)?.toUpperCase()}
                  </div>
                )}
                <div className="flex justify-between w-full">
                  <div className=" text-lg font-semibold text-slate-900 font-outfit">
                    {data?.name}
                  </div>
                  <Button
                    onClick={() => {
                      navigate(`/player-details/${data?.userId}`);
                      closeDialog();
                    }}
                  >
                    View Profile
                  </Button>{" "}
                </div>
              </div>

              {/* Details */}
              {detailsData
                ?.filter((item) => item?.isDisplay)
                ?.map((item, index) => (
                  <div
                    key={index}
                    className="group flex justify-between gap-4 py-4 border-b transition-all hover:bg-slate-50"
                  >
                    <span className="text-sm font-medium text-slate-500">
                      {item?.Label}:
                    </span>
                    <span className="text-sm font-medium text-slate-800 text-right break-words">
                      {item?.value}
                    </span>
                  </div>
                ))}
              {/* Booked Slots */}
              {data?.slotDetails?.length > 0 && (
                <>
                  <div className="mt-10 mb-5 flex items-center text-lg font-semibold text-slate-900 font-outfit">
                    <span className="mr-3 h-5 w-1 rounded bg-gradient-to-b from-[#2bace2] to-[#1a8fc9]" />
                    Booked Slots
                  </div>

                  <Accordion allowZeroExpanded className="border-none">
                    <AccordionItem className="mb-3 overflow-hidden rounded-xl border-2 border-slate-200 bg-white transition hover:shadow-sm">
                      <AccordionItemHeading>
                        <AccordionItemButton className="flex items-center justify-between p-3 bg-gradient-to-br from-slate-50 to-slate-100 hover:from-slate-100 hover:to-slate-200 transition">
                          <span className="font-semibold text-slate-700 capitalize">
                            {data?.slotDetails?.length > 0 &&
                              data?.slotDetails[0]?.arenaName}
                          </span>
                          <IoIosArrowDown className="text-xl text-[#2bace2] transition-transform" />
                        </AccordionItemButton>
                      </AccordionItemHeading>

                      <AccordionItemPanel className="p-5 animate-slideDown">
                        <div className="grid grid-cols-[repeat(auto-fill,minmax(130px,1fr))] gap-3">
                          {data?.slotDetails?.map((time, i) => (
                            <div
                              key={i}
                              className=" border-1 border-gray-200 px-4  text-center text-sm font-semibold text-gray-600 transition py-3 rounded-lg  bg-gray-200 text-black cursor-not-allowed"
                            >
                              {time.fromTime}-{time.toTime}
                            </div>
                          ))}
                        </div>
                      </AccordionItemPanel>
                    </AccordionItem>
                  </Accordion>
                </>
              )}
              {/* Assigned Users */}
              {data?.joinPlayersData?.length > 0 && (
                <>
                  <div className="mt-8 mb-5 flex items-center text-lg font-semibold text-slate-900 font-outfit">
                    <span className="mr-3 h-5 w-1 rounded bg-gradient-to-b from-[#2bace2] to-[#1a8fc9]" />
                    Assigned Users
                  </div>

                  <div className="grid grid-cols-[repeat(auto-fill,minmax(200px,1fr))] gap-4 max-sm:grid-cols-[repeat(auto-fill,minmax(140px,1fr))]">
                    {data?.joinPlayersData?.map((item, index) => (
                      <div
                        key={index}
                        className="relative flex flex-col items-center gap-2 rounded-xl border-2 border-slate-200 bg-gradient-to-br from-slate-50 to-slate-100 p-4 transition-all hover:border-[#2bace2] hover:shadow-lg"
                      >
                        {item?.profileImageUrl ? (
                          <img
                            src={item?.profileImageUrl}
                            alt={item?.name}
                            className="h-14 w-14 rounded-full border-4 border-white object-cover shadow-md"
                          />
                        ) : (
                          <div className="h-14 w-14 rounded-full bg-gradient-to-br from-[#2bace2] to-[#1a8fc9] flex items-center justify-center text-white text-xl font-semibold shadow-md capitalize">
                            {item?.name?.[0]}
                          </div>
                        )}
                        {item?.isGameCreater && (
                          <div className="absolute top-2 right-2">
                            <FaStar className="h-6 w-6 text-yellow-500" />
                          </div>
                        )}
                        <span className="text-sm font-medium text-slate-700 text-center">
                          {item?.name}
                        </span>

                        {item?.id === userData?.id ? (
                          <span className="rounded-full bg-brand-gradient px-3 py-1 text-[10px] font-semibold text-white">
                            You
                          </span>
                        ) : (
                          <CgProfile
                            onClick={() =>
                              navigate(`/player-details/${item?.id}`)
                            }
                            className="h-8 w-8 text-[#2bace2] cursor-pointer transition hover:scale-110 hover:text-[#1a8fc9]"
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(AssignedMatchDetailsDialog);
